<template>
  <!--SECTION INDUSTRIES-->
  <main>
    <div class="bank">
      <div class="container-db bread-container">
        <div class="bread-crumbs">
          <router-link to="/">Home</router-link>
          <span class="bread-separator">/</span>
          <span class="bread-current"
            >Currency research, analysis and news platform
          </span>
        </div>
      </div>
      <div class="container-db">
        <h1 class="bank-title">
          Currency Research, Analysis and News Platform
        </h1>
      </div>
    </div>
    <div class="descrip-result-wrapper">
      <div class="descrip-result-text">
        <div class="container-db">
          <div class="decription-container">
            <div class="description portfolio-container">
              <div class="portfolio-container-top">
                <div>
                  <h2>Project Description</h2>
                  <p>
                    This analytical platform was developed for traders and investors who need real-time information about the cryptocurrency market. It combines financial news, analytical reports, trading signals, and forecasts, helping users make informed decisions.
                  </p>

                  <div class="tech-features-section">
                    <div class="container-db bank-tech">
                      <div class="tech-features-wrapper">
                        <div class="features">
                          <h2 class="tech-features-title">Client’s Business Needs</h2>
                          <p>The client aimed to create a comprehensive platform that consolidates various sources of analytical data and financial news into a single, user-friendly environment. The main challenges to address included:</p>
                          <ul>
                            <li class="marked-item">
                              The lack of a unified platform providing both analytical reports and trading signals.
                            </li>
                            <li class="marked-item">A highly fragmented financial information market, forcing traders to use multiple services simultaneously.</li>
                            <li class="marked-item">High noise levels in financial news, making decision-making difficult.</li>
                          </ul>
                          <p>The platform was designed to solve these problems by offering verified information and analysis in one place.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  class="portfolio-img"
                  v-lazyload
                  data-url="/img/images-db/case-studies/Cryptocurrency.webp"
                  alt="cryptobanking"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-db container-mark">
      <h2>Key Features</h2>
      <ul class="features">
        <li class="marked-item">
          Monthly Cryptocurrency Reports – in-depth market insights and forecasts.
        </li>
        <li class="marked-item">
          Weekly Expert Webinars – live discussions on crypto market trends and strategies.
        </li>
        <li class="marked-item">
          Daily Newsletters – essential market updates in a convenient format.
        </li>
        <li class="marked-item">
          Discord Integration – a community space for traders to discuss strategies, signals, and analysis.
        </li>
        <li class="marked-item">
          Beginner Knowledge Base – educational materials for those new to trading.
        </li>
      </ul>
    </div>
    <div class="container-db container-mark">
      <h2>Functionality & UX/UI</h2>
      <ul class="features">
        <li class="marked-item">
          Intuitive Design: A user-friendly interface allows quick access to essential information.
        </li>
        <li class="marked-item">
          Responsive Layout: Fully optimized for mobile devices to ensure accessibility from anywhere.
        </li>
        <li class="marked-item">
          Content Personalization: Users can customize their news feed and receive only relevant reports and signals.
        </li>
        <li class="marked-item">
          Secure Accounts: Two-factor authentication and advanced data encryption for security.
        </li>
      </ul>
    </div>
    <div class="container-db container-mark">
      <h2>Development Process</h2>
      <ul class="features">
        <li class="marked-item">
          Analysis & Planning: Identifying the target audience, creating UI/UX prototypes.
        </li>
        <li class="marked-item">
          Development: Writing code, integrating APIs for financial data retrieval.
        </li>
        <li class="marked-item">
          Testing: Functionality checks, bug fixes, and performance optimization.
        </li>
        <li class="marked-item">
          Launch & Support: Implementing analytics tools and continuously updating data.
        </li>
      </ul>
    </div>
    <div class="container-db container-mark">
      <h2>Project Results</h2>
      <ul class="features">
        <li class="marked-item">
          +5,000 active users within the first three months after launch.
        </li>
        <li class="marked-item">
          >1,000 subscribers to analytical reports in the first month of operation.
        </li>
        <li class="marked-item">
          80% of users stay on the platform for more than 5 minutes per session, indicating high engagement.
        </li>
        <li class="marked-item">
          Positive client feedback on content quality and usability.
        </li>
      </ul>
      <p>Based on user feedback, the team plans to introduce additional features, including integration with third-party analytics services and expanded personalization options.</p>
    </div>

    <div class="container-db container-info">
      <h2>Conclusion</h2>
      The developed platform has become an effective solution for traders and investors looking for high-quality financial analysis and forecasts. Its key advantages include convenience, quick access to information, and integration with popular services.
    </div>

    <div class="relevant-case-studies">
      <div class="container-db">
        <h2>portfolio</h2>
        <div class="slider-container">
          <div class="relevant-case-studies-slider">
            <slick ref="slick" :options="slickOptions">
              <div class="case-slider-item">
                <router-link to="cannabis-platform">
                  <div class="case-studies-item">
                    <h3>Cannabis Platform</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="doctormed">
                  <div class="case-studies-item">
                    <h3>DoctorMed</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="social-network-for-dog-owners">
                  <div class="case-studies-item">
                    <h3>Social Network for Dog Owners</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="real-estate-platform">
                  <div class="case-studies-item">
                    <h3>Real Estate</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="art-galleries-development">
                  <div class="case-studies-item">
                    <h3>ArtGallery</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="banking-app">
                  <div class="case-studies-item">
                    <h3>Banking Application</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="markets-exchanges">
                  <div class="case-studies-item">
                    <h3>Markets and Exchanges</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="flexiswap-nft-swap-platform">
                  <div class="case-studies-item">
                    <h3>NFT Market and Swapping</h3>
                  </div>
                </router-link>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </div>
    <AcquaintedSection />
    <div
      v-lazyload
      data-src="/img/images-db/parallax/stone2.webp"
      class="lazy-bg bottom-stone"
    ></div>
    <script v-html="jsonld" type="application/ld+json"></script>
  </main>
</template>
<script>
import Slick from "vue-slick";
import AcquaintedSection from "../AcquaintedSection";
let vm = {};
export default {
  name: "CurrencyResearchAnalysisNewsPlatform",
  metaInfo: {
    title: "Currency Research & Crypto Analysis Platform | Real-Time Trading Insights",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Analytical platform for traders and investors: up-to-date news, trading signals, forecasts and reports on cryptocurrencies. Personalized content, expert webinars and secure access.",
      },
      {
        vmid: "og:image:type",
        name: "og:image:type",
        content: "image/webp",
      },
      {
        vmid: "og:title",
        name: "og:title",
        content:
          "Currency Research & Crypto Analysis Platform | Real-Time Trading Insights",
      },
      {
        vmid: "og:description",
        name: "og:description",
        content:
          "Analytical platform for traders and investors: up-to-date news, trading signals, forecasts and reports on cryptocurrencies. Personalized content, expert webinars and secure access.",
      },
      // {
      //   vmid: "og:image",
      //   name: "og:image",
      //   content:
      //     "https://devbrother.com/img/images-db/case-studies/art-solutions.webp",
      // },
      {
        vmid: "og:type",
        name: "og:type",
        content: "website",
      },
      // {
      //   vmid: "og:url",
      //   name: "og:url",
      //   content: "https://devbrother.com/cases/art-galleries",
      // },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content:
          "Currency Research & Crypto Analysis Platform | Real-Time Trading Insights",
      },
      {
        vmid: "twitter:description",
        name: "twitter:description",
        content:
          "Analytical platform for traders and investors: up-to-date news, trading signals, forecasts and reports on cryptocurrencies. Personalized content, expert webinars and secure access.",
      },
      // {
      //   vmid: "twitter:image",
      //   name: "twitter:image",
      //   content:
      //     "https://devbrother.com/img/images-db/case-studies/art-solutions.webp",
      // },
    ],
  },
  components: { Slick, AcquaintedSection },
  mounted() {
			this.addCanonicalLink();
  },
	methods: {
			addCanonicalLink: () => {
				const link = document.createElement('link');
				link.setAttribute('rel', 'canonical');
				link.setAttribute('href', 'https://devbrother.com/cases/currency-research-analasis-news-platform');

				const oldLink = document.querySelector('link[rel="canonical"]');
				if (oldLink) {
					document.head.removeChild(oldLink);
				}

				document.head.appendChild(link);
			},
	},
  data() {
    const jsonld = {
      "@context": "https://schema.org",
      "@type": "IndividualProduct",
      name: "Currency research",
      description: "Currency research",
    };
    return {
      jsonld,
      slickOptions: {
        prevArrow:
          '<div class="prev-arrow"><img src="/img/images-db/Arrow.svg" alt="arrow" class="arrow" width="26" height="11"/><img src="/img/images-db/Arrow-hover.svg" alt="arrow" class="arrow-hover" width="26" height="11"/></div>',
        nextArrow:
          '<div class="next-arrow"><img src="/img/images-db/Arrow.svg" alt="arrow" class="arrow" width="26" height="11"/><img src="/img/images-db/Arrow-hover.svg" alt="arrow" class="arrow-hover" width="26" height="11"/></div>',
        slidesToShow: 4,
        slidesToScroll: 1,
        // centerMode: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              prevArrow: "",
              nextArrow: "",
              dots: true,
              customPaging: function (slider, i) {
                return '<div class="slick-mobile-dot"></div>';
              },
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
    };
  },
};
</script>
<style scoped lang="scss">
.tech-features-wrapper {
  .features {
    flex-basis: auto;
  }
}

.container-db {
  margin-top: 50px;
}

.container-info, .container-mark {
  line-height: 1.8;
}
</style>
